import ROUTE_NAMES from './routeNames';

import BellIcon from '@/images/bell.svg?component';

const meta = {
    title: 'Notifications',
    icon: BellIcon,
    permissions: (): string[] => [],
};

const Notifications = () => import('../views/Notification/Notifications.vue');
export default [
    {
        path: 'show/all',
        name: ROUTE_NAMES.NOTIFICATIONS_ALL,
        component: Notifications,
        meta: {
            ...meta,
            menuTitle: 'All',
        },
    },
    {
        path: 'show/reply',
        name: ROUTE_NAMES.NOTIFICATIONS_REPLY,
        component: Notifications,
        meta: {
            ...meta,
            menuTitle: 'Reply',
        },
    },
    {
        path: 'show/tag',
        name: ROUTE_NAMES.NOTIFICATIONS_TAG,
        component: Notifications,
        meta: {
            ...meta,
            menuTitle: 'Tag',
        },
    },
    {
        path: 'show/sharing',
        name: ROUTE_NAMES.NOTIFICATIONS_SHARING,
        component: Notifications,
        meta: {
            ...meta,
            menuTitle: 'Sharing',
        },
    },
    {
        path: 'show/upload-link',
        name: ROUTE_NAMES.NOTIFICATIONS_UPLOAD_LINK,
        component: Notifications,
        meta: {
            ...meta,
            menuTitle: 'UploadLink',
        },
    },
    {
        path: 'show/audio',
        name: ROUTE_NAMES.NOTIFICATIONS_AUDIO,
        component: Notifications,
        meta: {
            ...meta,
            menuTitle: 'Audio',
        },
    },
    {
        path: 'show/conversion',
        name: ROUTE_NAMES.NOTIFICATIONS_CONVERSION,
        component: Notifications,
        meta: {
            ...meta,
            menuTitle: 'Conversion',
        },
    },
    {
        path: 'show/multiview',
        name: ROUTE_NAMES.NOTIFICATIONS_MULTIVIEW,
        component: Notifications,
        meta: {
            ...meta,
            menuTitle: 'Multiview',
        },
    },
    {
        path: 'show/transcription',
        name: ROUTE_NAMES.NOTIFICATIONS_TRANSCRIPTION,
        component: Notifications,
        meta: {
            ...meta,
            menuTitle: 'Transcription',
        },
    },
];
